import React from "react";
import { connect } from "react-redux";

const SeparatingLine = ({ Customer }) => {
    let colour = "#CF122F";
    if (Customer) {
        colour = Customer.Colour;
    }
    return <hr style={{ borderColor: colour }} />;
};

export default connect(state => ({ Customer: state.TradeCustomer }))(SeparatingLine);



// WEBPACK FOOTER //
// ./src/components/SeparatingLine.js